var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-portlet kt-portlet--tabs kt-portlet-opportunity"},[_vm._t("header"),_c('div',_vm._b({},'div',_vm.$attrs,false),[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }